import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { LayoutService } from './app/layout/service/layout.service';
import { AppFloatingConfigurator } from './app/layout/component/app.floatingconfigurator';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ToastModule, AppFloatingConfigurator],
  template: `
    <p-toast />
    <router-outlet />
    <!-- Hidden floating configurator to initialize PrimeNG theme (primary/surface/preset) from LayoutService defaults -->
    <app-floating-configurator class="hidden" />
  `,
})
export class AppComponent {
  private messageService = inject(MessageService);
  private layoutService = inject(LayoutService);

  ngOnInit() {
    this.layoutService.notifyToaster.subscribe((message: any) => {
      let severity = 'info';
      if (message.type === 'success') {
        severity = 'success';
      } else if (message.type === 'error') {
        severity = 'error';
      }
      this.messageService.add({
        summary: message.type === 'success' ? 'Success' : 'Error',
        severity: severity,
        detail: message.text,
      });
    });
  }
}
